import * as yup from 'yup';

const phoneRules =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
// eslint-disable-next-line import/prefer-default-export
export const validateSchema = yup.object().shape({
  phone: yup
    .string()
    .min(11, 'phone number should be 11 chars')
    .max(11, 'Phone number should be 11 chars')
    .matches(phoneRules, { message: 'please enter a valid phone number' })
    .required(' Phone number is required'),
  password: yup.string().required('Password is required')
  // .min(
  //   8,
  //   'password is too short - password must contain 8 or more characters with at least one of each: uppercase, lowercase, number and special character'
  // )
  // .min(8, 'Must be 8 characters or more')
  // .matches(/[a-z]+/, 'One lowercase character')
  // .matches(/[A-Z]+/, 'One uppercase character')
  // .matches(/[@$!%*#?&]+/, 'One special character')
  // .matches(/\d+/, 'One number')
});
